/* lm-d13-geo.js – CRO-60 (2026-10-16): moved from the d13_geo_prompt Custom Liquid section (sections/header-group.json), which
   was an inline <script> on every page. Settings come from <script type="application/json" id="d13-geo-cfg">. */
(function () {
  var box = document.getElementById('d13-geo');
  var cfgEl = document.getElementById('d13-geo-cfg');
  if (!box || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var SEEN = 'lm_d13_geo_seen';
  var EUR_NOTICE_DISMISSED = 'lm_d13_eur_notice_dismissed';
  var CONFIRMED = 'lm_country_confirmed';
  var design = cfg.design;
  var seen = false;
  var noticeDismissed = false;
  try {
    seen = !!window.localStorage.getItem(SEEN);
    noticeDismissed = !!window.localStorage.getItem(EUR_NOTICE_DISMISSED);
  } catch (e) {}

  // Independent of the one-visit prompt: must render after /localization has set lm_d13_geo_seen.
  var initialCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'EUR';
  var selectedNeedsEurNotice = initialCurrency === 'EUR' && ['NO', 'MX', 'BR', 'AR', 'CL', 'CO', 'HT'].indexOf(String(cfg.iso || '').toUpperCase()) !== -1;
  var noticeEl = document.getElementById('d13-eur-notice');
  var noticeTextEl = noticeEl && noticeEl.querySelector('[data-d13-eur-notice-text]');
  var eurNoticeCopy = {
    en: 'Prices are charged in EUR; your bank may convert the amount.',
    lt: 'Kainos apmokamos EUR; tavo bankas gali konvertuoti sumą.',
    de: 'Die Preise werden in EUR berechnet; Ihre Bank kann den Betrag umrechnen.',
    fr: 'Les prix sont facturés en EUR ; votre banque peut convertir le montant.',
    sv: 'Priserna debiteras i EUR; din bank kan växla beloppet.',
    no: 'Prisene betales i EUR; banken din kan konvertere beløpet.',
    da: 'Priserne opkræves i EUR; din bank kan omregne beløbet.',
    nl: 'Prijzen worden in EUR berekend; je bank kan het bedrag omrekenen.',
    fi: 'Hinnat veloitetaan euroina; pankkisi voi muuntaa summan.'
  };
  if (selectedNeedsEurNotice && !noticeDismissed && noticeEl && noticeTextEl) {
    var noticeLocale = String(cfg.locale || 'en').toLowerCase().split('-')[0];
    noticeTextEl.textContent = eurNoticeCopy[noticeLocale] || eurNoticeCopy.en;
    noticeEl.hidden = false;
    var noticeClose = noticeEl.querySelector('[data-d13-eur-notice-close]');
    if (noticeClose) noticeClose.addEventListener('click', function () {
      noticeEl.hidden = true;
      try { window.localStorage.setItem(EUR_NOTICE_DISMISSED, '1'); } catch (e) {}
    });
  }
  // Bet koks ŠALIES pasirinkimas temos perjungikliu (header, footer, meniu stalčius) = patvirtinta šalis.
  // DEV-21: kalbos formos (temos kalbos perjungiklis header'yje, stalčiuje ir footer'yje bei šios juostos
  // mygtukas) eina tuo pačiu /localization keliu, bet šalies lauko neturi, tad kalbos keitimas šalies
  // NEpatvirtina ir prekės puslapio pristatymo eilutė toliau taiso šalį pagal lankytojos IP.
  // CRO-03 (2026-09-24): registruojama prieš vieno apsilankymo return, kad šalies pasirinkimas būtų įsimintas kiekviename puslapyje.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !f.querySelector) return;
    if ((f.getAttribute('action') || '').indexOf('/localization') === -1) return;
    if (!f.querySelector('[name="country_code"]')) return;
    markSeen();
    markConfirmed();
  }, true);

  function markSeen() { try { window.localStorage.setItem(SEEN, '1'); } catch (e) {} }
  function markConfirmed() { try { window.localStorage.setItem(CONFIRMED, '1'); } catch (e) {} }
  function isConfirmed() { try { return !!window.localStorage.getItem(CONFIRMED); } catch (e) { return false; } }

  if (cfg.page_type === 'collection') return; if (seen && !design) return;

  // DEV-141: šalių sąrašas imamas iš footer'io, o jis dar neišanalizuotas, kai vykdomas šis header'io skriptas.
  // CRO-60 (2026-10-16): the bar itself is built once the page has loaded and the browser is idle, not during page load.
  function later() { if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 3000 }); else setTimeout(start, 200); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);

  function fillCountries(select) {
    var source = document.querySelector('x-listbox[data-country-list-source]');
    if (!source) return;
    var frag = document.createDocumentFragment();
    source.querySelectorAll('button[name="country_code"]').forEach(function (b) {
      var o = document.createElement('option');
      o.value = b.value;
      o.textContent = b.textContent.replace(/\s+/g, ' ').trim();
      if (b.value === cfg.iso) o.selected = true;
      frag.appendChild(o);
    });
    if (!frag.childNodes.length) return;
    select.textContent = '';
    select.appendChild(frag);
    select.value = cfg.iso;
  }

  function start() {
  var lineEl = box.querySelector('[data-d13-line]');
  var codeInput = box.querySelector('[data-d13-code]');
  var select = box.querySelector('[data-d13-select]');
  var switchBtn = box.querySelector('[data-d13-switch]');
  var keepBtn = box.querySelector('[data-d13-keep]');
  var form = box.querySelector('form');
  fillCountries(select);
  function hide() { box.hidden = true; document.body.style.paddingBlockEnd = ''; markSeen(); }
  function show() { box.hidden = false; document.body.style.paddingBlockEnd = box.offsetHeight + 'px'; markSeen(); }
  var quickAdd = document.querySelector('product-quick-add');
  /* DEV-288: on collection pages the phone bottom bar (.lm-bbar) sits at the bottom too, so the bar is lifted above it. */
  var bottomBar = document.querySelector('.lm-bbar');
  function place() {
    var lift = quickAdd && quickAdd.classList.contains('is-visible') && window.innerWidth < 700 ? quickAdd.offsetHeight : 0;
    if (!lift && bottomBar && window.innerWidth < 700) lift = bottomBar.offsetHeight;
    box.style.transform = lift ? 'translateY(-' + lift + 'px)' : '';
  }
  if (quickAdd) {
    new MutationObserver(place).observe(quickAdd, { attributes: true, attributeFilter: ['class'] });
  }
  if (quickAdd || bottomBar) {
    window.addEventListener('resize', place);
    place();
  }

  box.querySelector('[data-d13-close]').addEventListener('click', hide);
  keepBtn.addEventListener('click', function () { markConfirmed(); hide(); });

  select.addEventListener('change', function () {
    if (select.value && select.value !== cfg.iso) {
      codeInput.value = select.value;
      markSeen(); markConfirmed();
      form.submit();
    }
  });
  switchBtn.addEventListener('click', function () { markSeen(); markConfirmed(); });

  function lineFor() {
    return cfg.tmpl;
  }

  // Tarifas ir šalis čia nerodomi: juosta nespėlioja Markets tarifo.
  lineEl.textContent = lineFor();

  // Lankytojos IP šalis; vienas kvietimas visam puslapiui – dalijamės su prekės puslapio D2 eilute
  function suggestion(exclude) {
    if (!window.__lmGeoSuggest) {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.__lmGeoSuggest = fetch(r + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(exclude), { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('http'); return res.json(); })
        .then(function (data) {
          var s = data && data.suggestions && data.suggestions[0];
          var c = s && s.parts && s.parts.country;
          return c && c.handle ? { code: c.handle, name: c.name } : null;
        });
    }
    return window.__lmGeoSuggest;
  }

  // Kalbos pasiūlymas: atskiras kvietimas, kad nepaliesčiau šalies pasiūlymo, kuriuo dalijasi prekės puslapio D2 eilutė
  function langSuggestion() {
    if (!window.__lmGeoLangSuggest) {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.__lmGeoLangSuggest = fetch(r + 'browsing_context_suggestions.json?language[enabled]=true', { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('http'); return res.json(); })
        .then(function (data) {
          var s = data && data.suggestions && data.suggestions[0];
          var l = s && s.parts && s.parts.language;
          return l && l.handle ? { code: l.handle, name: l.endonym_name || l.name } : null;
        });
    }
    return window.__lmGeoLangSuggest;
  }

  var langBtn = box.querySelector('[data-d13-lang]');
  var langInput = box.querySelector('[data-d13-lang-code]');

  if (langBtn && langInput) {
    langSuggestion().then(function (l) {
      if (!l || !l.code) return;
      var code = String(l.code).toLowerCase();
      var base = code.split('-')[0];
      var here = String(cfg.locale || '').toLowerCase().split('-')[0];
      if (base === here) return;
      var known = (cfg.locales || []).filter(function (x) {
        var c = String(x.code).toLowerCase();
        return c === code || c.split('-')[0] === base;
      })[0];
      if (!known) return;
      langInput.value = known.code;
      langBtn.textContent = cfg.lang_labels[base] || known.name;
      langBtn.hidden = false;
    }).catch(function () {});
  }

  // CRO-03: patvirtintai šaliai IP pasiūlymo nerodome.
  if (isConfirmed()) {
    show();
    return;
  }

  suggestion(cfg.iso).then(function (s) {
    var opt = s && s.code ? select.querySelector('option[value="' + s.code + '"]') : null;
    if (s && s.code !== cfg.iso && opt) {
      var name = s.name || opt.textContent.replace(/\s*\(.*$/, '');
      lineEl.textContent = lineFor();
      codeInput.value = s.code;
      // CRO10-D6 (2026-09-24): the select keeps showing the SELECTED market; the IP country is only offered by the Switch button.
      switchBtn.textContent = cfg.switch.replace('%C', name);
      switchBtn.hidden = false;
      keepBtn.textContent = cfg.keep.replace('%C', cfg.name);
      keepBtn.hidden = false;
    }
  }).catch(function () {}).then(show);
  }
})();
